import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketplacePage } from './marketplace.page';
import { MarketplaceDetailsComponent } from './marketplace-details/marketplace-details.component';
import { BaseAppRouteGuardService } from '../core/services/base-app-route-guard.service';
import { MarketplaceFilterComponent } from './marketplace-filter/marketplace-filter.component';
import { MarketplaceCartComponent } from './marketplace-cart/marketplace-cart.component';

const routes: Routes = [
  {
    path: '',
    component: MarketplacePage,
    data:{
      title:'MarketPlace'
    }
  },

 
  {
    path: 'details/:id',
    component: MarketplaceDetailsComponent,
  },
  {
    path: 'cart',
    component: MarketplaceCartComponent,
  }
  // {
  //   path: 'filter',
  //   component: MarketplaceFilterComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketplaceRoutingModule {

}
